export const batteryDescriptionHTML = (
  vehicleText = ''
) => `<h3 class="font-bold">Sobre nuestras baterías para carro</h3>

<p>
  Si estás buscando una batería confiable para tu vehículo ${
    vehicleText ? `<strong class="font-bold">${vehicleText}</strong>` : ''
  }, aquí la tenemos. Contamos con baterías potentes, duraderas,
  de alto rendimiento y a precios accesibles, ideales para cualquier tipo de carro o camioneta.
  <br/>
  Ya sea que necesités más potencia, una batería resistente para trabajo pesado o una opción económica, tenemos la que
  mejor se ajusta a tus necesidades.
  Baterías de alto rendimiento.
</p>
<p>
  Las baterías TAB son reconocidas por su potencia, resistencia y durabilidad, ideales para la mayoría de vehículos
  modernos.
  <br/>
  Son perfectas para autos como el Honda Civic o el Ford Escape, y vienen con garantía desde dos años, para que manejés
  con confianza y sin preocupaciones.
  <br/>
  <br/>
  Si buscás aún más potencia y duración, las baterías TAB 5G ofrecen un rendimiento superior, diseñadas para vehículos con alto consumo eléctrico como sistemas de sonido, luces LED y accesorios. Estas incluyen garantía desde tres años.
  <br/>
  También contamos con opciones de alto desempeño como las baterías TAB EFB y TAB AGM, y opciones más económicas como las ENDURA, ideales para volver al camino sin gastar de más.
</p>

<br/>
<h3 class="font-bold">
  ¿Cuál batería debo comprar?
</h3>
<p>
  Elegir la batería correcta es fundamental para que tu carro encienda sin problemas y te dure más tiempo.
  <br/>
  Asegurate de escoger el tamaño y tipo adecuado para el modelo de tu vehículo. Si no estás seguro, con gusto te ayudamos a encontrar la batería que le queda exacta.
</p>

<br/>
<h3 class="font-bold">
  ¿Por qué cambiar la batería?
</h3>
<p>
  Las baterías se desgastan con el tiempo.
  El calor, el frío y el uso constante pueden hacer que se dañen más rápido.
  <br/>
  Muchas veces la batería ya está débil antes de que llegue el invierno, y termina fallando cuando tratás de encender el carro en clima frío.
</p>

<br/>
<h3 class="font-bold">
  ¿Cómo funciona una batería?
</h3>
<p>
  La batería es la que proporciona la energía eléctrica inicial para encender el motor.
  Dentro de ella ocurren reacciones químicas que generan corriente eléctrica, la cual se distribuye por todo el sistema
  del carro para alimentar luces, radio, aire acondicionado y otros componentes.
  Sin batería, simplemente el vehículo no arranca.
</p>

<br/>
<h3 class="font-bold">
  ¿Cómo saber si la batería está fallando?
</h3>
<p>
  Algunas señales comunes son:
<ul class="list-disc list-inside ml-4">
  <li> • El motor tarda en encender o suena lento al arrancar.</li>
  <li> • Las luces bajan de intensidad o los sistemas eléctricos se apagan.</li>
  <li> • La batería tiene más de tres o cuatro años.</li>
  <li> • Ha estado expuesta a temperaturas muy altas o muy bajas.</li>
</ul>
Si notás alguno de estos síntomas, es momento de revisarla antes de que te deje varado.
</p>

<br/>
<h3 class="font-bold">
  ¿Cuánto dura una batería?
</h3>
<p>
  Por lo general, una batería dura entre tres y cinco años, dependiendo del uso y del clima.
  <br/>
  El calor excesivo y los viajes largos pueden acortar su vida útil.
  <br/>
  Si tu batería tiene más de cuatro años, lo recomendable es revisarla o cambiarla pronto.
  <br/>
  Ofrecemos revisión y carga gratuita para comprobar el estado de tu batería, y además reciclamos la vieja cuando instalás una nueva.
  <br/>
  De esta manera cuidás tu carro y también el medio ambiente.
</p>

<br/>
<h3 class="font-bold">
  En resumen
</h3>
<p>
  La mayoría de las baterías duran entre tres y cinco años.
  <br />
  Si la tuya ya pasó de los cuatro años, es momento de revisarla.
  Nosotros te ayudamos con diagnóstico gratuito, cambio rápido y la mejor  garantía del mercado.
</p>
`;
